export let focusedViewFilterText = "ZLdhq";
export default {focusedViewFilterText};